import { render, staticRenderFns } from "./MSmsToolTipComp.vue?vue&type=template&id=238e48b8&"
import script from "./MSmsToolTipComp.vue?vue&type=script&lang=js&"
export * from "./MSmsToolTipComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports